import { Tag } from 'antd';
import styled from 'styled-components';

export const StyledTag = styled(Tag)<{ $mini?: boolean }>`
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: ${props => (props.$mini ? '14px' : '20px')};
  padding-inline: ${props => (props.$mini ? '4px' : '7px')};
  &&& {
    font-weight: 600;
  }
`;
